import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { AddressFormData, AddressValidity } from '@src/view_models/Address';
import TextField from '@src/components/shared/form_fields/TextField.vue';
import { computed } from 'vue';
import CityAutocompleteField from '@src/components/shared/form_fields/CityAutocompleteField.vue';
import CountryAutocompleteField from '@src/components/shared/form_fields/CountryAutocompleteField.vue';
import type { Country } from '@src/view_models/Country';

interface Props {
	formData: AddressFormData;
	showError: AddressValidity;
	countries: Country[];
	postCodeValidation: string;
	countryWasRestored: boolean;
	fieldIdNamespace?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PostalAddressFields',
  props: {
    formData: {},
    showError: {},
    countries: {},
    postCodeValidation: {},
    countryWasRestored: { type: Boolean },
    fieldIdNamespace: {}
  },
  emits: [ 'field-changed' ],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;

const showStreetWarning = computed<boolean>( () => /^\D+$/.test( props.formData.street.value ) );
const fieldIdNamespace = props.fieldIdNamespace ? `${props.fieldIdNamespace}-` : '';

const onCountryFieldChanged = ( country: Country | undefined ) => {
	if ( country ) {
		props.formData.postcode.pattern = country.postCodeValidation;
	} else {
		props.formData.postcode.pattern = props.postCodeValidation;
	}

	emit( 'field-changed', 'country' );

	if ( props.formData.postcode.value !== '' ) {
		emit( 'field-changed', 'postcode' );
	}
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TextField, {
      name: "street",
      id: `${_unref(fieldIdNamespace)}address-form-street`,
      "input-id": `${_unref(fieldIdNamespace)}street`,
      modelValue: __props.formData.street.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.formData.street.value) = $event)),
      "show-error": __props.showError.street,
      "error-message": _ctx.$t('donation_form_street_error'),
      autocomplete: "street-address",
      label: _ctx.$t( 'donation_form_street_label' ),
      placeholder: _ctx.$t( 'donation_form_street_placeholder' ),
      "is-max-width-field": true,
      onFieldChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('field-changed', 'street')))
    }, _createSlots({ _: 2 }, [
      (showStreetWarning.value)
        ? {
            name: "message",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t( 'donation_form_street_number_warning' )), 1)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["id", "input-id", "modelValue", "show-error", "error-message", "label", "placeholder"]),
    _createVNode(TextField, {
      name: "postcode",
      id: `${_unref(fieldIdNamespace)}address-form-post-code`,
      "input-id": `${_unref(fieldIdNamespace)}post-code`,
      modelValue: __props.formData.postcode.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.formData.postcode.value) = $event)),
      "show-error": __props.showError.postcode,
      "error-message": _ctx.$t('donation_form_zip_error'),
      autocomplete: "postal-code",
      label: _ctx.$t( 'donation_form_zip_label' ),
      placeholder: _ctx.$t( 'donation_form_zip_placeholder' ),
      "placeholder-warning": "donation_form_zip_placeholder_warning",
      "is-max-width-field": true,
      onFieldChanged: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('field-changed', 'postcode')))
    }, null, 8, ["id", "input-id", "modelValue", "show-error", "error-message", "label", "placeholder"]),
    _createVNode(CityAutocompleteField, {
      modelValue: __props.formData.city.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((__props.formData.city.value) = $event)),
      id: `${_unref(fieldIdNamespace)}address-form-city`,
      "input-id": `${_unref(fieldIdNamespace)}city`,
      "scroll-target-id": `${_unref(fieldIdNamespace)}address-form-city`,
      "show-error": __props.showError.city,
      label: _ctx.$t( 'donation_form_city_label' ),
      "error-message": _ctx.$t( 'donation_form_city_error' ),
      postcode: __props.formData.postcode.value,
      "is-max-width-field": true,
      onFieldChanged: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('field-changed', 'city' )))
    }, null, 8, ["modelValue", "id", "input-id", "scroll-target-id", "show-error", "label", "error-message", "postcode"]),
    _createVNode(CountryAutocompleteField, {
      modelValue: __props.formData.country.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((__props.formData.country.value) = $event)),
      id: `${_unref(fieldIdNamespace)}address-form-country`,
      "input-id": `${_unref(fieldIdNamespace)}country`,
      "scroll-target-id": `${_unref(fieldIdNamespace)}address-form-country`,
      countries: __props.countries,
      "was-restored": __props.countryWasRestored,
      "show-error": __props.showError.country,
      "is-max-width-field": true,
      onFieldChanged: onCountryFieldChanged
    }, null, 8, ["modelValue", "id", "input-id", "scroll-target-id", "countries", "was-restored", "show-error"])
  ], 64))
}
}

})